<template>
  <BModalConfirm
    ref="modal"
    cancel-btn="Отменить"
    success-btn="Добавить"
    class="FormTemplatesFormEditor"
    @submit="onSubmit"
    @closed="$emit('closed')"
  >
    <template #title-text>
      Загрузка списка
      <div class="caption">
        Скопируйте и вставьте cписок.
        <br>Каждый элемент списка должен быть в отдельной строке.
      </div>
    </template>
    <BEditor
      v-model="model"
      placeholder="Введите формулу*"
      :extensions="[]"
      :editor-props="editorProps"
      min-height="420px"
      dense
      class="FormTemplatesFormEditor__editor"
    />
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'


export const BEditor = () => import(
  /* webpackChunkName: "BEditor" */
  '@/components/forms/BEditor.vue'
)

export const fromHTML = (text) => text && text
  .replace(/<(.+?)>/g, '\n')
  .replace(/\n\n/g, '\n')
  .replace(/&nbsp;/g, '')
  .split('\n')
  .filter(Boolean)

export const editorProps = {
  transformPastedHTML: (string) => {
    if (!string.includes('</table>')) return string

    const matches = string
      .replace(/(\r)?\n/g, ' ')
      .match(/<td(.+?)>(.+?)<\/td>/g)
      .map((match) => (
        match.replace(/<td(.+?)>/g, '').replace(/<\/td>/g, '')
      ))

    return matches.join('</p><p>').replace(/(.*)/, '<p>$1</p>')
  },
}

export default {
  name: 'FormTemplatesFormEditor',
  components: {
    BModalConfirm,
    BEditor,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data: (vm) => ({
    editorProps,
    model: vm.list.join('</p><p>').replace(/(.*)/, '<p>$1</p>'),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
    onSubmit() {
      const list = fromHTML(this.model)
      this.close({ list })
    },
  },
}
</script>

<style lang="scss">
.FormTemplatesFormEditor {
  &__editor {
    p {
      margin: 0 !important;
    }
  }
}
</style>
